import React from 'react';

import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

// Empty until opportunity stage history is available from Salesforce.
export default function StageHistoryTable() {
  return (
    <TableContainer component={Paper} variant="outlined">
      <Table aria-label="Stage history" size="small">
        <TableHead>
          <TableRow>
            <TableCell width={48} />
            <TableCell>Stage</TableCell>
            <TableCell>Close date</TableCell>
            <TableCell>Last modified by</TableCell>
            <TableCell>Last modified date</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell align="center" colSpan={5} sx={{ color: 'text.secondary', py: 4 }}>
              No stage history for this opportunity yet.
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}
